<template>
  <transition name="fade-in">
      <div class="dialog-ctr confirm-box" v-if="showDialog" @touchmove.prevent>
        <div class="dialog confirm-dialog" @touchmove.prevent>
          <div class="dialog-info sign-out-tips">{{ content }}</div>
          <div class="dialog-operate">
            <div class="dialog-btn" @click="cancelFunc">{{ cancelText || '取消' }}</div>
            <div class="dialog-btn" @click="okFunc">{{ okText || '确定' }}</div>
          </div>
        </div>
      </div>
    </transition>
</template>

<script>
export default {
  name: '',
  components: {},
  props: {
    content: String,
    okText: String,
    cancelText: String,
    ok: Function,
    cancel: Function,
    showDialog: {
      type: Boolean,
      default: false,
    },
  },
  // data() {
  //   return {
  //     showDialog: false,
  //   }
  // },

  mounted() {
  },

  methods: {
    cancelFunc() {
      this.showDialog = false;
      this.cancel && this.cancel();
    },
    okFunc() {
      this.showDialog = false;
      this.ok && this.ok();
    },
    handleConfirm() {
      this.showDialog = false
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="scss">
</style>
